import { ResponseContext } from "../../../@api";

export async function getRequestBodyContent<T>(context: ResponseContext): Promise<T | undefined> {
  return context.init ? await new Response(context.init.body).json() : undefined;
}

export async function getResponseBodyContent(context: ResponseContext): Promise<any> {
  const clonedResponse: Response = context.response.clone();
  return await clonedResponse.json();
}

export function createResponse(body: any, context: ResponseContext, init?: ResponseInit): Response {
  return new Response(JSON.stringify(body), {
    status: init?.status ?? context.response.status,
    statusText: init?.statusText ?? context.response.statusText,
    headers: init?.headers ?? context.response.headers,
  });
}
